import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToolContext } from "../fluent/hoc/fluentToolWrapper";
import { MessageBar } from "../fluent/primitives/messageBar";
export class MessageLineComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    renderFluent() {
        return (_jsx(MessageBar, { title: "", message: this.props.text, intent: this.props.color === "Red" ? "error" : this.props.color === "Green" ? "success" : this.props.color === "Yellow" ? "warning" : "info" }));
    }
    renderOriginal() {
        if (this.props.icon) {
            return (_jsxs("div", { className: "iconMessageLine", children: [_jsx("div", { className: "icon", style: { color: this.props.color ? this.props.color : "" }, children: _jsx(FontAwesomeIcon, { icon: this.props.icon }) }), _jsx("div", { className: "value", title: this.props.text, children: this.props.text })] }));
        }
        return (_jsx("div", { className: "messageLine", children: _jsx("div", { className: "value", title: this.props.text, style: { color: this.props.color ? this.props.color : "" }, children: this.props.text }) }));
    }
    render() {
        return _jsx(ToolContext.Consumer, { children: ({ useFluent }) => (useFluent ? this.renderFluent() : this.renderOriginal()) });
    }
}
//# sourceMappingURL=messageLineComponent.js.map